import { DatePipe, PercentPipe } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { crop_Datas } from 'src/app/models/farmer-land.model';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { FarmerLandDetailService } from 'src/app/services/farmer-land-detail.service';
import { FarmersApplicationService } from 'src/app/services/farmers-application.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { JEService } from 'src/app/services/je-services.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import saveAs from 'file-saver';

interface UploadEvent {
  originalEvent: Event;
  files: File[];
}


@Component({
  selector: 'app-vendor-budget-details',
  templateUrl: './vendor-budget-details.component.html',
  styleUrls: ['./vendor-budget-details.component.scss'],
  providers: [DatePipe]
})
export class VendorBudgetDetailsComponent implements OnInit {
  public outletMasterData: any;
  public selectedOutlet: any = null;
  public selectedOutletToGetData: any = null;
  public selectedBenefitedArea: any = null;
  public VendorTableData: any;
  public selectedBenefitedAreaToGetData: any = null;
  public agreementNo: any = null;
  public agreementNoToGetData: any = null;
  public ipAddress: any;
  public isSubmitted: boolean = false;
  public userId: any;
  public contractorId: any;
  public subscriptions: any = [];
  public subjectSub: any;
  public xslxToJsonDataPersonal: any[] = [];
  public xslxToJsonDataLand: any[] = [];
  public xslxToJsonDataBank: any[] = [];
  public uploadFile: any;
  public personalDetailsCols: any[];
  public landDetailsCols: any[];
  public bankDetailsCols: any[];
  public showViewDocDialog: boolean = false;
  public personalDetailsForm: FormGroup;
  public updatePersonalDetailsForm: FormGroup;
  public addedPersonalData: any[] = [];
  public todayDate: Date;
  public filteredVillage: any[];
  public villageList: any;
  public isCasteCertificteOptional: boolean = false;
  public isCasteCertificateMandatory: boolean = false;
  // public farmerLandForm: FormGroup;
  public cropMergeList: any;
  public nodes2: any[];
  public cropTypeList: any[];
  public submitted: boolean = false;
  public valRadio: boolean = false;
  selectedNodes1: any[] = [];
  selectedCorpModelList: any;
  selectedCorpModel: crop_Datas;
  blockSpace: RegExp = /^[^\s,]([^,]*[^\s,])?$/;
  public addedLandData: any = [];
  public landDocArray: any = [];
  public uploadedlandFiles: any[] = [];
  public uploadedAadharFiles: any[] = [];
  public selectedcompMaster: any;
  public contractorOutletList = [];
  public componentMasterList = [];
  public farmerCategoryList = [];
  public departmentList = [
    { name: 'Agriculture', code: 'Agriculture' },
    { name: 'Horticulture', code: 'Horticulture' },
    { name: 'MICADA 1.0', code: 'MICADA' },
  ];
  public yearArray: any = [];
  public innerWidth: number;
  public showSubsidyArea: boolean = false;
  public minDate: Date;
  public maxDate: Date;
  public addedFarmerData: any = [];
  public DataForm: any = [];
  public estimationDetailsForm: FormGroup;
  public filteredmiVendorList: any = [];
  public miVendorList: any = [];
  public category: any;
  public component: any;
  public sizePrice: any;
  public estimationTableData: any = [];
  public expandedRows: any = {};
  public hideGetDataButton: boolean = false;
  public farmerPastSubsidyList: any = [];
  public totalPortableAreaCount: any = 0;
  public totalPortableCount: any = 0;
  public totalMiniAreaCount: any = 0;
  public totalMiniCount: any = 0;
  public totalDripAreaCount: any = 0;
  public totalDripCount: any = 0;
  public programWiseData: any = [];
  public agreementNoList: any = [];
  public showErrMsgOfInvArea: boolean = false;
  public invAreaMsg: any;
  public showUpdatePersonalDialog: boolean = false;
  public selectedApplicationNo: any;
  public selectedFarmerId: any;
  public loadedEstimateDatafromServer: any = [];
  public chunkList: any = [];
  public chunkIdToGetData: any;
  public selectedFarmerForEstimation: any = [];
  
  public componentItemsList: any = [];
  public componentItemsListAfterFilter: any = [];
  public isAllDetailsAdded: boolean = false;
  public addedCompTableExport: MenuItem[];

  constructor(
    private loader: AppLoaderService,
    private activityRecordService: ActivityRecordService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private _personalDetalSer: FarmersDetailsService,
    private ipService: IpAddressService,
    private fb: FormBuilder,
    private fApplicationService: FarmersApplicationService,
    private vendorService: VendorDashboardService,
    private jeService: JEService,
    private cryptoJsService: CryptoJsService,
    private datePipe: DatePipe,
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }
  getEmail: any;
  getMobile: any;
  getVendor: any;
  vendorDetails: any;

  ngOnInit(): void {
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));
    this.contractorId = JSON.stringify(token?.officeCode);
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    this.getVendorFullDetailsByEmail();
    // this.getContractorOutletList(this.contractorId, 0, '');
    this.getIP();
    // this.getFarmerCategoryList();
    this.getYearList();
    // this.loadComponentMaster();
    this.estimationDetailsForm = this.fb.group({
      // vendor: ['', [Validators.required]],
      // mobileNo: ['', [Validators.required]],
      componentItem: ['', [Validators.required]],
      programmeName: ['', [Validators.required]],
      // category: ['', [Validators.required]],
      // component: ['', [Validators.required]],
      // sizePrice: ['', [Validators.required]],
      price: [0, Validators.required],
      // cmL_Certificate: ['', Validators.required],
      cmL_Certificate: [''],
      // email: ['', [Validators.required]],
      // cmlSerialNo: ['', Validators.required],
      cmlSerialNo: [''],
      // cmlValidity: ['', Validators.required],
      cmlValidity: [''],
      // gstAmount: [{ value: 0, disabled: true }],
      // gstRate: [{ value: 18, disabled: true }],
      calculatedPrice: [{ value: 0, disabled: true }]
    });
    // this.onPriceChanges();
    // this.onChanges();

    this.addedCompTableExport = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.VendorTableData, 'Added MI Component Details');
        },
      },
      // {
      //   label: 'Download Pdf',
      //   icon: 'pi pi-fw pi-download',
      //   command: () => {
      //     this.downloadSheetAsPdf(
      //       this.appVerificationModel,
      //       'App_Verification_List'
      //     );
      //   },
      // },
    ];
  }

  populateData() {
    // this.estimationDetailsForm.patchValue({
    //   vendor: this.getVendor,
    //   mobileNo: this.getMobile,
    //   email: this.getEmail
    // });
  }

  getVendorFullDetailsByEmail() {
    this.jeService.getVendorFullDetailsByEmail(this.userId).subscribe({
      next: (data) => {
        this.vendorDetails = data;
        // this.vendorFormData = data.personalDetails.$values[0];
        this.VendorTableData = data.componentDetails.$values;

        this.getMobile = data.personalDetails.$values[0].Mobile;
        this.getEmail = data.personalDetails.$values[0].Email_ID;
        this.getVendor = data.personalDetails.$values[0].Vendor_Name;
        // this.vendorAttachmentData = data.attachmentDetails.$values;
        // Handle your form display logic here

        this.loadComponentMaster(this.getEmail);
        this.loadComponentList(this.getEmail);
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: err,
        });
        // setTimeout(()=> this.onClickBack(), 1300);
      }
    });
  }

  onPriceChanges() {
    this.estimationDetailsForm.get('price').valueChanges.subscribe((price) => {
      const gstAmount = 0.18 * price;
      this.estimationDetailsForm.patchValue({
        gstAmount: gstAmount.toFixed(2)
      });
    });
  }

  onChanges(): void {
    this.estimationDetailsForm.valueChanges.subscribe(val => {
      this.calculatePrice();
    });
  }

  calculatePrice(): void {
    const price = this.estimationDetailsForm.get('price')?.value || 0;
    const gstAmount = this.estimationDetailsForm.get('gstAmount')?.value || 0;
    const calculatedPrice1 = parseFloat(price) + parseFloat(gstAmount);
    this.estimationDetailsForm.patchValue({
      calculatedPrice: calculatedPrice1
    }, { emitEvent: false });
  }

  // get f() {
  //   return this.farmerLandForm.controls;
  // }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  getYearList() {
    let today = new Date();
    let month = today.getMonth();
    let year = today.getFullYear();
    let prevMonth = month === 0 ? 11 : month - 1;
    let prevYear = prevMonth === 11 ? year - 8 : year - 7;
    let nextMonth = month === 11 ? 0 : month + 1;
    let nextYear = nextMonth === 0 ? year : year;
    this.minDate = new Date();
    this.minDate.setMonth(prevMonth);
    this.minDate.setFullYear(prevYear);
    this.maxDate = new Date();
    this.maxDate.setMonth(nextMonth);
    this.maxDate.setFullYear(nextYear);
    this.innerWidth = window.innerWidth;

    for (
      let i = this.minDate.getFullYear();
      i <= this.maxDate.getFullYear();
      i++
    ) {
      this.yearArray.push({ name: i.toString(), code: i.toString() });
    }
  }

  onSelectOutlet() {
    this.selectedBenefitedArea = this.selectedOutlet?.CCA_A;
  }

  onSelectOutletToGetData() {
    this.agreementNoToGetData = null;
    this.agreementNoList = [];
    this.chunkList = [];
    this.agreementNoToGetData = null;
    this.chunkIdToGetData = null;

    this.selectedBenefitedAreaToGetData = this.selectedOutletToGetData?.CCA_A;
    let conId = this.selectedOutletToGetData?.ContractorCode;
    let outletId = this.selectedOutletToGetData?.OutletId;
    this.getAgreementNumberList(conId, outletId, this.userId, '');
  }

  getAgreementNumberList(contractorId, outletId, userId, status) {
    this.loader.start();
    this.fApplicationService
      .getAgreementByContractor(contractorId, outletId, userId, status)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          this.agreementNoList = res;
        },
        error: (err) => {
          this.loader.close();
          this.agreementNoList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onSelectBenefitedArea() {

  }

  getContractorOutletList(contractorId, userId, status) {
    this.loader.start();
    this.fApplicationService
      .getOutletByContractor(contractorId, userId, status)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          this.contractorOutletList = res;
        },
        error: (err) => {
          this.loader.close();
          this.contractorOutletList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  getFarmerCategoryList() {
    this.loader.start();
    this.fApplicationService
      .getFarmerCategory()
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          this.farmerCategoryList = res;
        },
        error: (err) => {
          this.loader.close();
          this.farmerCategoryList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  filterVillage(event: any) {
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.villageList.length; i++) {
      const village = this.villageList[i];
      if (village.Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(village);
      }
    }
    this.filteredVillage = filtered;
  }

  loadComponentMaster(emailId) {
    this.loader.start();
    this.vendorService
      .getVendorProgMaster(emailId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          this.componentMasterList = res;
        },
        error: (err) => {
          this.loader.close();
          this.componentMasterList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  loadComponentList(emailId) {
    this.loader.start();
    this.vendorService
      .getVendorRegCompMaster(emailId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          if(res.length > 0) {
            this.componentItemsList = res.map((item, index) => ({
              ...item,
              dataToShow: `${index + 1}. ${item?.Program_Name} - ${item?.category} - ${item?.component} - ${item?.size}`,
              serialNumber: index + 1,
              // disabled: false,
              // disabled: this.VendorTableData.some((vendorItem) => vendorItem?.MI_System === item?.ProgID && vendorItem?.Component_Cat === item?.category && vendorItem?.Component === item?.component && vendorItem?.Component_Size === item?.size) ? true : false
              disabled: this.VendorTableData.some((vendorItem) => vendorItem?.AutoIdCompTbl === item?.AutoId) ? true : false
              }));

            this.isAllDetailsAdded = this.componentItemsList.some((item) => item.disabled == false);
          }else {
            this.componentItemsList = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'No component found for this vendor.',
            });
          }
            
        },
        error: (err) => {
          this.loader.close();
          this.componentItemsList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress', JSON.stringify(this.ipAddress));
      });
    }
  }

  // public setCurrentPosition() {
  //   if ('geolocation' in navigator) {
  //     navigator.geolocation.getCurrentPosition((position) => {
  //       this.showPosition(position);
  //     });
  //   }
  // }

  // showPosition(position) {

  //   let geocoder = new google.maps.Geocoder();
  //   let latlng = {
  //     lat: position.coords.latitude,
  //     lng: position.coords.longitude,
  //   };
  //   this.f.latitude.setValue(position.coords.latitude);
  //   this.f.longitude.setValue(position.coords.longitude);
  // }

  getSelectedCorpType() {
    this.selectedCorpModel = new crop_Datas();
    this.selectedCorpModelList = [];
    let selectedLabels = [];

    this.selectedCorpModelList = this.selectedNodes1.map((val) => ({
      type_of_crop_ID: val.parentData,
      crop_ID: val.data,
    }));
  }

  onCropSelect(val) {
    if (val.value.length > 4) {
      this.messageService.add({
        severity: 'info',
        summary: 'Crop Limit Exceeds',
        detail: 'Maximun 4 crop is allowed',
      });
    }
  }

  onAadharUpload(event, formcontrol, uploadElement) {
    const encData = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encData);

    const tokenInfo = loginDetails.get('tokenInfo') ? loginDetails.get('tokenInfo') : null;
    const officeCode = tokenInfo['officeCode'] ? tokenInfo['officeCode'] : null;

    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);
    this.loader.start();
    this._personalDetalSer
      .uploadFile(data, officeCode, formcontrol)
      .subscribe((resp: any) => {
        this.loader.close();
        if (resp.statusCode == 200 && resp.message == 'Sucessfull') {
          this.uploadedAadharFiles = [];
          for (let file of event.files) {
            this.uploadedAadharFiles.push(file);

          }

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Aadhar Uploaded Successfully',
          });
          this.personalDetailsForm.patchValue({ [formcontrol]: resp.data });
        }
      });
    uploadElement.clear();
  }

  onUpdateAadharUpload(event, formcontrol, uploadElement) {
    const encData = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encData);

    const tokenInfo = loginDetails.get('tokenInfo') ? loginDetails.get('tokenInfo') : null;
    const officeCode = tokenInfo['officeCode'] ? tokenInfo['officeCode'] : null;

    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);

    this.loader.start();
    this._personalDetalSer
      .uploadFile(data, officeCode, formcontrol)
      .subscribe((resp: any) => {
        this.loader.close();
        if (resp.statusCode == 200 && resp.message == 'Sucessfull') {
          this.uploadedAadharFiles = [];
          for (let file of event.files) {
            this.uploadedAadharFiles.push(file);

          }

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Aadhar Uploaded Successfully',
          });
          this.updatePersonalDetailsForm.patchValue({ [formcontrol]: resp.data });
        }
      });
    uploadElement.clear();
  }

  onLandUpload(event, formcontrol, uploadElement) {
    const encData = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encData);

    const tokenInfo = loginDetails.get('tokenInfo') ? loginDetails.get('tokenInfo') : null;
    const officeCode = tokenInfo['officeCode'] ? tokenInfo['officeCode'] : null;

    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);
    this.loader.start();
    this._personalDetalSer
      .uploadFile(data, officeCode, formcontrol)
      .subscribe((resp: any) => {
        this.loader.close();
        if (resp.statusCode == 200 && resp.message == 'Sucessfull') {
          this.uploadedlandFiles = [];
          for (let file of event.files) {
            this.uploadedlandFiles.push(file);

          }

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'File Uploaded Successfully',
          });
          // this.farmerLandForm.patchValue({ [formcontrol]: resp.data });
        }
      });
    uploadElement.clear();
  }

  onSelectSubsidyAvail(val) {

    if (val == 1) {
      this.personalDetailsForm.controls['installedSystem'].setValidators(
        Validators.required
      );
      this.personalDetailsForm.controls[
        'installedSystem'
      ].updateValueAndValidity();
      this.personalDetailsForm.controls['yearSubsudy'].setValidators(
        Validators.required
      );
      this.personalDetailsForm.controls['yearSubsudy'].updateValueAndValidity();
      this.personalDetailsForm.controls['onCostSubsidyBased'].setValidators(
        Validators.required
      );
      this.personalDetailsForm.controls[
        'onCostSubsidyBased'
      ].updateValueAndValidity();
      this.personalDetailsForm.controls['departmentSubsidy'].setValidators(
        Validators.required
      );
      this.personalDetailsForm.controls[
        'departmentSubsidy'
      ].updateValueAndValidity();
    } else {
      this.personalDetailsForm.controls['installedSystem'].clearValidators();
      this.personalDetailsForm.controls[
        'installedSystem'
      ].updateValueAndValidity();
      this.personalDetailsForm.controls['yearSubsudy'].clearValidators();
      this.personalDetailsForm.controls['yearSubsudy'].updateValueAndValidity();
      this.personalDetailsForm.controls['onCostSubsidyBased'].clearValidators();
      this.personalDetailsForm.controls[
        'onCostSubsidyBased'
      ].updateValueAndValidity();
      this.personalDetailsForm.controls['departmentSubsidy'].clearValidators();
      this.personalDetailsForm.controls[
        'departmentSubsidy'
      ].updateValueAndValidity();

      // this.personalDetailsForm.controls.installedSystem.setValue('');
    }
  }

  onSelectSubsidyAvailUpdate(val) {

    if (val == 1) {
      this.updatePersonalDetailsForm.controls['installedSystem'].setValidators(
        Validators.required
      );
      this.updatePersonalDetailsForm.controls[
        'installedSystem'
      ].updateValueAndValidity();
      this.updatePersonalDetailsForm.controls['yearSubsudy'].setValidators(
        Validators.required
      );
      this.updatePersonalDetailsForm.controls['yearSubsudy'].updateValueAndValidity();
      this.updatePersonalDetailsForm.controls['onCostSubsidyBased'].setValidators(
        Validators.required
      );
      this.updatePersonalDetailsForm.controls[
        'onCostSubsidyBased'
      ].updateValueAndValidity();
      this.updatePersonalDetailsForm.controls['departmentSubsidy'].setValidators(
        Validators.required
      );
      this.updatePersonalDetailsForm.controls[
        'departmentSubsidy'
      ].updateValueAndValidity();
    } else {
      this.updatePersonalDetailsForm.controls['installedSystem'].clearValidators();
      this.updatePersonalDetailsForm.controls[
        'installedSystem'
      ].updateValueAndValidity();
      this.updatePersonalDetailsForm.controls['yearSubsudy'].clearValidators();
      this.updatePersonalDetailsForm.controls['yearSubsudy'].updateValueAndValidity();
      this.updatePersonalDetailsForm.controls['onCostSubsidyBased'].clearValidators();
      this.updatePersonalDetailsForm.controls[
        'onCostSubsidyBased'
      ].updateValueAndValidity();
      this.updatePersonalDetailsForm.controls['departmentSubsidy'].clearValidators();
      this.updatePersonalDetailsForm.controls[
        'departmentSubsidy'
      ].updateValueAndValidity();

      // this.updatePersonalDetailsForm.controls.installedSystem.setValue('');
    }
  }

  onSelectOnCostS(val) {
    if (val == 1) {
      this.personalDetailsForm.controls['departmentSubsidy'].setValidators(
        Validators.required
      );
      this.personalDetailsForm.controls[
        'departmentSubsidy'
      ].updateValueAndValidity();
    } else {
      this.personalDetailsForm.controls['departmentSubsidy'].clearValidators();
      this.personalDetailsForm.controls[
        'departmentSubsidy'
      ].updateValueAndValidity();
    }
  }

  onSubmitPersonalDetails() {


    if (this.personalDetailsForm.valid) {
      // this.addedPersonalData.push(this.personalDetailsForm.value);
      // this.personalDetailsForm.reset();
    } else {
      this.personalDetailsForm.markAllAsTouched();
    }
  }

  onAddFarmerForm() {
    this.onSubmitPersonalDetails();


    if (this.selectedOutlet == null) {
      this.messageService.add({
        severity: 'info',
        summary: 'Info',
        detail: 'Select Outlet.',
      });
      return;
    }

    if (this.agreementNo == null) {
      this.messageService.add({
        severity: 'info',
        summary: 'Info',
        detail: 'Enter Agreement No.',
      });
      return;
    }


    if (this.personalDetailsForm.invalid) {
      this.messageService.add({
        severity: 'info',
        summary: 'Info',
        detail: 'Fill Personal Details Properly.',
      });
      return;
    }

    if (this.addedLandData.length == 0) {
      this.messageService.add({
        severity: 'info',
        summary: 'Info',
        detail: 'Fill Land Detail.',
      });
      return;
    }

    let personalDetails = this.personalDetailsForm.value;
    let addedLandDetails = this.addedLandData;

    let farmerDeatils = {
      landDetailsData: addedLandDetails,
      contractorId: this.contractorId,
      outletId: this.selectedOutlet?.OutletId,
      agreementNo: this.agreementNo,
      name: personalDetails?.name,
      farmerFatherName: personalDetails?.fatherName,
      ppP_ID: personalDetails?.pppId,
      aadharno: personalDetails?.aadharNo,
      aadhar_path: personalDetails?.aadharPhotoPath,
      mobileno: personalDetails?.mobileNo,
      castcode: personalDetails?.casteCode,
      villagecode: personalDetails?.villageCode?.Code,
      mfmbNo: personalDetails?.mfmbNo,
      farmerCategory: personalDetails?.farmerCategory?.AutoID,
      proposedSystemToBeInstalled: personalDetails?.componentMaster?.Program_Id,

      isSubsidyAvailabe: personalDetails?.isSubsidyAvailabe
        ? personalDetails?.isSubsidyAvailabe
        : 0,
      installedSystem: personalDetails?.installedSystem?.Program_Id
        ? personalDetails?.installedSystem?.Program_Id
        : 0,
      yearSubsudy: personalDetails?.yearSubsudy
        ? personalDetails?.yearSubsudy
        : '',
      onCostSubsidyBased: personalDetails?.onCostSubsidyBased
        ? personalDetails?.onCostSubsidyBased
        : 0,
      departmentSubsidy: personalDetails?.departmentSubsidy
        ? personalDetails?.departmentSubsidy
        : '',

      network_ID: this.ipAddress,
      terminal_ID: this.ipAddress,
    };

    this.submitFarmerData([farmerDeatils]);
    // this.addedFarmerData.push(farmerDeatils);


    // this.personalDetailsForm.reset();
    // this.uploadedAadharFiles = [];
    // this.addedLandData = [];
  }

  onUpdatePersonalDetails() {


    if (this.updatePersonalDetailsForm.valid) {
      this.updatePersonalDetails();
      // this.addedPersonalData.push(this.personalDetailsForm.value);
      // this.personalDetailsForm.reset();
    } else {
      this.updatePersonalDetailsForm.markAllAsTouched();
      this.messageService.add({
        severity: 'info',
        summary: 'Info',
        detail: 'Fill Personal Details Properly.',
      });
      return;
    }
  }

  submitFarmerData(reqBody) {
    let reqBodyFinal = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this.vendorService
      .insertFarmerDataByContractor(reqBodyFinal)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();

          if (res == 'Success') {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: 'Details submitted successfully.',
            });

            this.personalDetailsForm.reset();
            this.uploadedAadharFiles = [];
            this.addedLandData = [];
            // this.selectedOutlet = null;
            // this.agreementNo = null;
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: res,
            });
          }
          this.activityRecordService.activityRecord(this.contractorId, 'Vendor Reg Insert Farmer Data', this.userId, new Date(), `${res}`, JSON.stringify(reqBodyFinal));
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });

          this.activityRecordService.activityRecord(this.contractorId, 'Vendor Reg Insert Farmer Data(Error)', this.userId, new Date(), `${err}`, JSON.stringify(reqBodyFinal));
        },
      });
  }


  updatePersonalDetails() {

    let updatedPersonalDetails = this.updatePersonalDetailsForm.value;



    let reqBoady = {
      FarmerId: this.selectedFarmerId,
      // contractorId: this.contractorId,
      // outletId: this.selectedOutlet?.OutletId,
      // agreementNo: this.agreementNo,
      name: updatedPersonalDetails?.name,
      farmerFatherName: updatedPersonalDetails?.fatherName,
      ppP_ID: updatedPersonalDetails?.pppId,
      aadharno: updatedPersonalDetails?.aadharNo,
      aadhar_path: updatedPersonalDetails?.aadharPhotoPath,
      mobileno: updatedPersonalDetails?.mobileNo,
      castcode: updatedPersonalDetails?.casteCode,
      villagecode: updatedPersonalDetails?.villageCode?.Code,
      mfmbNo: updatedPersonalDetails?.mfmbNo,
      farmerCategory: updatedPersonalDetails?.farmerCategory,
      proposedSystemToBeInstalled: updatedPersonalDetails?.componentMaster,

      isSubsidyAvailabe: updatedPersonalDetails?.isSubsidyAvailabe ? updatedPersonalDetails?.isSubsidyAvailabe : 0,
      installedSystem: updatedPersonalDetails?.installedSystem ? updatedPersonalDetails?.installedSystem : 0,
      yearSubsudy: updatedPersonalDetails?.yearSubsudy ? updatedPersonalDetails?.yearSubsudy : '',
      onCostSubsidyBased: updatedPersonalDetails?.onCostSubsidyBased ? updatedPersonalDetails?.onCostSubsidyBased : 0,
      departmentSubsidy: updatedPersonalDetails?.departmentSubsidy ? updatedPersonalDetails?.departmentSubsidy : '',

      network_ID: this.ipAddress,
      terminal_ID: this.ipAddress,
    };

    // this.submitFarmerData([farmerDeatils]);

    this.updateFarmerPersonalData(reqBoady);
  }

  updateFarmerPersonalData(reqBody) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this.vendorService
      .updateFarmerPersonalDetails(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();

          if (res == 'Personal details updated successfully.') {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: res,
            });

            this.updatePersonalDetailsForm.reset();
            this.uploadedAadharFiles = [];
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Error Message',
              detail: res,
            });
          }

          this.activityRecordService.activityRecord(this.contractorId, 'Vendor Reg Update Farmer Data(Error)', this.userId, new Date(), `${res}`, JSON.stringify(reqBodyAfterEncypt));

        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
          this.activityRecordService.activityRecord(this.contractorId, 'Vendor Reg Update Farmer Data(Error)', this.userId, new Date(), `${err}`, JSON.stringify(reqBodyAfterEncypt));
        },
      });
  }

  clearFormData() {
    this.personalDetailsForm.reset();
    this.uploadedAadharFiles = [];
    this.addedLandData = [];
    this.farmerPastSubsidyList = [];
  }

  onClickGetFarmerData() {
    let outletId = this.selectedOutletToGetData?.OutletId;
    let agreementNo = this.agreementNoToGetData?.AgreementNo;
    let chunkId = this.chunkIdToGetData?.ChunkId ? this.chunkIdToGetData?.ChunkId : 0;

    this.estimationTableData = [];
    this.addedFarmerData = [];

    if (outletId && agreementNo) {
      if (chunkId != 0) {
        this.getEPCFarmerDetails(agreementNo, outletId, chunkId);
        // this.getEPCEstimationDetails(this.contractorId, outletId, agreementNo, chunkId);
      } else {
        this.getEPCFarmerDetails(agreementNo, outletId, chunkId);
      }
    } else {
      this.messageService.add({
        severity: 'info',
        summary: 'Info Message',
        detail: 'Select Outlet and Agreement Number.',
      });
    }
  }

  // getEPCEstimationDetails(contractorId, outletId, agreementNo, chunkId) {
  //   this.loader.start();
  //   this.vendorService
  //     .getContractorEstimation(contractorId, outletId, agreementNo, chunkId)
  //     .pipe(first())
  //     .subscribe({
  //       next: (data) => {
  //         // this.hideGetDataButton = false;
  //         this.loader.close();

  //         let resp: any = data;
  //         if (resp.length > 0) {
  //           this.loadedEstimateDatafromServer = resp;
  //           let respArr = resp.map((val) => this.estimationTableData.push({
  //             programmeId: val?.ProgramID,
  //             programmeName: val?.Program_Name,
  //             CatID: val?.catId,
  //             CatName: val?.category,
  //             ComponentID: val?.ComponentID,
  //             ComponentName: val?.Component,
  //             // SizeID: estimationVal?.sizePrice?.sizeId,
  //             // SizePriceName: estimationVal?.sizePrice?.sizeAndPrice,
  //             Size: val?.Size,
  //             SizeID: val?.SizeId,
  //             Quantity: val?.Quantity,
  //             // CoveredArea: val?.CoveredArea
  //           }))

  //           // this.estimationTableData.concat(respArr);

  //         } else {
  //           this.loadedEstimateDatafromServer = [];
  //           this.estimationTableData = [];
  //           if (this.chunkIdToGetData) {
  //             this.messageService.add({
  //               severity: 'info',
  //               summary: 'Info Message',
  //               detail: 'Data Not Found',
  //             });
  //           }
  //         }
  //       },
  //       error: (err) => {
  //         // this.hideGetDataButton = false;
  //         this.loadedEstimateDatafromServer = [];
  //         this.estimationTableData = [];
  //         this.loader.close();
  //         this.messageService.add({
  //           severity: 'error',
  //           summary: 'Error Message',
  //           detail: err,
  //         });
  //       },
  //     });
  // }

  getEPCFarmerDetails(agreementNo, outletId, chunkId) {
    this.loader.start();
    this.vendorService
      .getEPCDetails(agreementNo, outletId, chunkId, this.userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();

          let resp: any = data;
          if (resp.length > 0) {
            this.hideGetDataButton = true;
            this.calValidationForEstimation(resp);
            this.addedFarmerData = data;
          } else {
            this.hideGetDataButton = false;
            this.addedFarmerData = [];
            this.programWiseData = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Found',
            });
          }
        },
        error: (err) => {
          this.hideGetDataButton = false;
          this.addedFarmerData = [];
          this.programWiseData = [];
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  calValidationForEstimation(data) {
    this.totalPortableAreaCount = 0;
    this.totalPortableCount = 0;
    this.totalMiniAreaCount = 0;
    this.totalMiniCount = 0;
    this.totalDripAreaCount = 0;
    this.totalDripCount = 0;

    data.map((val) => {

      if (val.ProposedSystem == 'Portable Sprinkler') {
        this.totalPortableAreaCount += parseFloat(val.TotalArea);
        this.totalPortableCount += 1;
      } else if (val.ProposedSystem == 'Mini Sprinkler') {
        this.totalMiniAreaCount += parseFloat(val.TotalArea);
        this.totalMiniCount += 1;
      } else if (val.ProposedSystem == 'Drip') {
        this.totalDripAreaCount += parseFloat(val.TotalArea);
        this.totalDripCount += 1;
      }
    });

    this.programWiseData = [
      {
        progName: 'Portable Sprinkler',
        totaAreaCount: this.totalPortableAreaCount,
        totalCount: this.totalPortableCount,
      },
      {
        progName: 'Mini Sprinkler',
        totaAreaCount: this.totalMiniAreaCount,
        totalCount: this.totalMiniCount,
      },
      {
        progName: 'Drip',
        totaAreaCount: this.totalDripAreaCount,
        totalCount: this.totalDripCount,
      },
    ];

    this.componentMasterList = [
      {
        Program_Id: 1,
        Program_Name: 'Portable Sprinkler',
        Active: true,
        disabled: this.totalPortableAreaCount == 0
      },
      {
        Program_Id: 2,
        Program_Name: 'Mini Sprinkler',
        Active: true,
        disabled: this.totalMiniAreaCount == 0
      },
      {
        Program_Id: 3,
        Program_Name: 'Drip',
        Active: true,
        disabled: this.totalDripAreaCount == 0
      },
    ]
  }

  onSubmitFormConsent(){
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Are you sure that you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon:"none",
      rejectIcon:"none",
      rejectButtonStyleClass:"p-button-text",
      accept: () => {
        this.onSubmitForm();
          // this.messageService.add({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted' });
      },
      reject: () => {
          // this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
      }
    });
  }

  onSubmitForm() {
    // let val = this.componentItemsList.find((item => item.disabled == false));

    // if(val){
    //   this.messageService.add({
    //     severity: 'warn',
    //     summary: 'Alert Message',
    //     detail: `${val?.dataToShow} is not added. Please add all items before submitting.`,
    //   });

    //   return;
    // }

    this.loader.start();
    let reqBody = this.estimationTableData.map(data => {
      return {
        AutoId: data?.AutoId,
        CML_Certificate: data?.CML_Certificate ? data?.CML_Certificate : '',
        CML_SrNo: data?.CML_SrNo ? data?.CML_SrNo : '',
        CML_Validity: data?.CML_Validity ? data?.CML_Validity : '',
        Component: data?.Component,
        Component_Cat: data?.Component_Cat,
        Component_Size: data?.Component_Size,
        GST_Amnt: data?.GST_Amnt,
        GST_Rate: data?.GST_Rate,
        MI_System: data?.MI_System,
        Price: data?.Price,
        calculated_Price: data?.calculated_Price,
        vendorId: this.contractorId,
      };
    });

    let isAllCompNotAdded = this.componentItemsList.some((item) => item.disabled == false);
    let reqBodyFinal = {
      DataModelVendorCompDetails: reqBody,
      AllCompAdded: !isAllCompNotAdded,
      Network_Id: this.ipAddress,
      Terminal_Id: this.ipAddress
    };

    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBodyFinal))
    }

    this.vendorService
      .insertVendorComponentDetails(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();

          if (data == 'Success') {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: data,
            });

            this.hideGetDataButton = false;
            this.addedFarmerData = [];
            this.programWiseData = [];
            this.estimationTableData = [];
            this.selectedFarmerForEstimation = [];
            this.getVendorFullDetailsByEmail();

            this.clearGetData();
          } else if (data.startsWith('Violation of PRIMARY KEY')) {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'You have added the same component multiple times. Please remove the duplicate one.',
            });
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data,
            });
          }

          this.activityRecordService.activityRecord(this.contractorId, 'Vendor Reg Estimation Submit', this.userId, new Date(), `${data}`, JSON.stringify(reqBodyFinal));
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });

          this.activityRecordService.activityRecord(this.contractorId, 'Vendor Reg Estimation Submit(Error)', this.userId, new Date(), `${err}`, JSON.stringify(reqBodyFinal));
        },
      });
  }

  getVendorList(programId) {
    this.loader.start();
    this.fApplicationService
      .getAllMIvenders(programId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          this.miVendorList = res;
        },
        error: (err) => {
          this.loader.close();
          this.miVendorList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  filterMIVendor(event: any) {
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.miVendorList.length; i++) {
      const vendor = this.miVendorList[i];
      if (vendor.Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(vendor);
      }
    }
    this.filteredmiVendorList = filtered;
  }

  onSelectProgramme() {
    // this.estimationDetailsForm.controls['category'].reset();
    // this.category = [];
    // this.estimationDetailsForm.controls['component'].reset();
    // this.component = [];
    // this.estimationDetailsForm.controls['sizePrice'].reset();
    // this.sizePrice = [];

    let programme = this.estimationDetailsForm.controls['programmeName'].value;
    let vendor = 0;

    this.estimationDetailsForm.controls['componentItem'].reset();
    this.estimationDetailsForm.controls['cmlSerialNo'].reset();
    this.estimationDetailsForm.controls['cmlValidity'].reset();
    this.estimationDetailsForm.controls['cmL_Certificate'].reset();
    this.estimationDetailsForm.controls['price'].reset();
    this.componentItemsListAfterFilter = [];
    this.componentItemsListAfterFilter = this.componentItemsList.filter((item)=> item.ProgID == programme?.Program_Id);
    // this.getCategoryDropdown(vendor, programme?.Program_Id);
  }

  getCategoryDropdown(vendorId, programId) {
    const reqBody = {
      VendorRegId: vendorId,
      ProgramId: programId,
    };
    this.loader.start();
    this.vendorService
      .getCategoryMasterVendorReg(reqBody)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.category = res.$values;
          this.loader.close();
        },
        error: (err) => {
          this.loader.close();
          this.category = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onSelectCategory() {
    this.estimationDetailsForm.controls['component'].reset();
    this.component = [];
    this.estimationDetailsForm.controls['sizePrice'].reset();
    this.sizePrice = [];
    let programme = this.estimationDetailsForm.controls['programmeName'].value;
    let category = this.estimationDetailsForm.controls['category'].value;
    let vendor = 0;
    this.getComponentDropdown(
      vendor,
      programme?.Program_Id,
      category?.categoryId
    );
  }

  getComponentDropdown(vendorId, programId, categoryId) {
    const reqBody = {
      VendorRegId: vendorId,
      ProgramId: programId,
      CategoryId: categoryId,
    };

    this.loader.start();
    this.vendorService
      .getComponentMasterVendorReg(reqBody)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          this.component = res.$values;
        },
        error: (err) => {
          this.loader.close();
          this.component = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onSelectComponent() {
    this.estimationDetailsForm.controls['sizePrice'].reset();
    this.sizePrice = [];
    let programme = this.estimationDetailsForm.controls['programmeName'].value;
    let category = this.estimationDetailsForm.controls['category'].value;
    let vendor = 0;
    let component = this.estimationDetailsForm.controls['component'].value;

    this.getSizeAndPriceDropdown(
      vendor,
      programme?.Program_Id,
      category?.categoryId,
      component?.componentId
    );
  }

  getSizeAndPriceDropdown(vendorRegId, programId, categoryId, componentId) {
    const reqBody = {
      VendorRegId: vendorRegId,
      ProgramId: programId,
      CategoryId: categoryId,
      ComponentId: componentId,
    };

    this.loader.start();
    this.vendorService
      .getSizePriceMasterVendorReg(reqBody)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.sizePrice = res.$values.map((val) => ({
            ...val,
            sizeOnly: val?.sizeAndPrice.split('and')[0],
          }));

          this.loader.close();
        },
        error: (err) => {
          this.loader.close();
          this.sizePrice = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onSelectSizePrice() {
    let sizePrice = this.estimationDetailsForm.controls['sizePrice'].value;
  }

  addEstimateData() {
    if(this.estimationDetailsForm.invalid){
      this.messageService.add({
        severity: 'info',
        summary: 'Info Message',
        detail: 'Fill all the details properly and upload the document',
      });
    }

    if (this.estimationDetailsForm.valid) {
      const newData = this.estimationDetailsForm.getRawValue();

      // Store the gstRate value before resetting
      const gstRateValue = this.estimationDetailsForm.get('gstRate')?.value;
      const ven = this.estimationDetailsForm.get('vendor')?.value;
      const emai = this.estimationDetailsForm.get('email')?.value;
      const mob = this.estimationDetailsForm.get('mobileNo')?.value;

      // this.DataForm = {
      //   MI_System: newData.programmeName?.Program_Id,
      //   Component_Cat: newData.category.categoryName,
      //   Component: newData.component.componentName,
      //   Component_Size: newData.sizePrice.sizeOnly,
      //   Price: parseFloat(newData.price),
      //   CML_SrNo: newData.cmlSerialNo,
      //   CML_Certificate: newData.cmL_Certificate,
      //   CML_Validity: this.datePipe.transform(newData.cmlValidity, 'yyyy-MM-dd'),
      //   GST_Amnt: newData.gstAmount ? parseFloat(newData.gstAmount) : 0,
      //   GST_Rate: newData.gstRate ? parseFloat(newData.gstRate) : 0,
      //   calculated_Price: parseFloat(newData.calculatedPrice) ? parseFloat(newData.calculatedPrice) : 0,
      // };

      this.DataForm = {
        SerialNo: newData.componentItem?.serialNumber,
        AutoId: newData.componentItem?.AutoId,
        MI_System_Name: newData.componentItem?.Program_Name,
        MI_System: newData.componentItem?.ProgID,
        Component_Cat: newData.componentItem?.category,
        Component: newData.componentItem?.component,
        Component_Size: newData.componentItem?.size,
        Price: parseFloat(newData.price),
        CML_SrNo: newData.cmlSerialNo,
        CML_Certificate: newData.cmL_Certificate,
        CML_Validity: this.datePipe.transform(newData.cmlValidity, 'yyyy-MM-dd'),
        GST_Amnt: newData.gstAmount ? parseFloat(newData.gstAmount) : 0,
        GST_Rate: newData.gstRate ? parseFloat(newData.gstRate) : 0,
        calculated_Price: parseFloat(newData.calculatedPrice) ? parseFloat(newData.calculatedPrice) : 0,
      };

      this.estimationTableData.push(this.DataForm);

      // Reset the form except gstRate
      // this.estimationDetailsForm.reset();
      // this.componentItemsListAfterFilter = [];
      this.estimationDetailsForm.get('componentItem')?.reset();
      this.estimationDetailsForm.get('cmlSerialNo')?.reset();
      this.estimationDetailsForm.get('cmlValidity')?.reset();
      this.estimationDetailsForm.get('cmL_Certificate')?.reset();
      this.estimationDetailsForm.get('price')?.reset();

      // Restore the gstRate value after reset
      this.estimationDetailsForm.get('gstRate')?.setValue(gstRateValue);
      this.estimationDetailsForm.get('vendor')?.setValue(ven);
      this.estimationDetailsForm.get('mobileNo')?.setValue(mob);
      this.estimationDetailsForm.get('email')?.setValue(emai);

      this.componentItemsList.find(item => item.serialNumber === newData.componentItem?.serialNumber).disabled = true;

      // console.log('estimationTableData', this.componentItemsList);
    }
  }


  onDeleteEstimationRow(val, index) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      // message: `Do you want to remove Estimation of Vendor: ${val?.vendor} and Amount ${val?.Amount}?`,
      message: `Do you want to remove estimation?`,
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: 'p-button-danger p-button-text',
      rejectButtonStyleClass: 'p-button-text p-button-text',
      acceptIcon: 'none',
      rejectIcon: 'none',

      accept: () => {
        this.estimationTableData.splice(index, 1);
        this.componentItemsList.find(item => item.AutoId == val?.AutoId).disabled = false;

        this.estimationDetailsForm.reset();
      },
      reject: () => {
        // this.messageService.add({ severity: 'info', summary: 'Rejected', detail: 'You have rejected' });
      },
    });
  }

  toggleRow(rowData: any) {
    if (this.expandedRows[rowData.landDetails]) {
      delete this.expandedRows[rowData.landDetails];
    } else {
      this.expandedRows[rowData.landDetails] = true;
    }
  }

  onRowSelect(val) {

    let farmerDataArr = val.data
    this.selectedFarmerForEstimation = [farmerDataArr];

    this.calValidationForEstimation(this.selectedFarmerForEstimation);
    if (!this.chunkIdToGetData) {
      this.estimationTableData = [];
    }
  }

  onRowUnselect(val) {

    this.selectedFarmerForEstimation = [];
    this.calValidationForEstimation(this.selectedFarmerForEstimation);
    this.estimationTableData = [];
  }

  clearGetData() {
    this.hideGetDataButton = false;
    this.addedFarmerData = [];
    this.programWiseData = [];
    this.estimationDetailsForm.reset();
    this.category = [];
    this.component = [];
    this.sizePrice = [];

    this.selectedOutletToGetData = null;
    this.selectedBenefitedAreaToGetData = null;
    this.agreementNoList = [];
    this.agreementNoToGetData = null;
    this.chunkList = [];
    this.chunkIdToGetData = null;

    this.estimationTableData = [];

    this.selectedFarmerForEstimation = [];
  }

  editPersonalDetails(val) {
    this.showUpdatePersonalDialog = true;

    this.selectedApplicationNo = val.APP_ID;
    this.selectedFarmerId = val.Farmer_ID;


    this.updatePersonalDetailsForm.patchValue({ name: val.Name });
    this.updatePersonalDetailsForm.patchValue({ fatherName: val.Father_name });
    this.updatePersonalDetailsForm.patchValue({ mobileNo: val.Mobile });

    this.updatePersonalDetailsForm.patchValue({ mfmbNo: val.MFMBNo });
    this.updatePersonalDetailsForm.patchValue({ pppId: val.PPP_ID });
    this.updatePersonalDetailsForm.patchValue({ casteCode: val.Caste_Code });


    // let village = this.villageList?.filter(val => val?.Code === val?.Village_Code)[0];
    let village = this.villageList?.find(({ val }) => val?.Code === val?.Village_Code);

    // this.updatePersonalDetailsForm.villageCode.setValue(village?.Name);
    // this.selectedVillage = village;

    this.updatePersonalDetailsForm.patchValue({ villageCode: village });
    this.updatePersonalDetailsForm.patchValue({ componentMaster: val.ProposedSystemId });
    this.updatePersonalDetailsForm.patchValue({ farmerCategory: val.FarmerCategory });

    this.updatePersonalDetailsForm.patchValue({ aadharNo: val.Aadhar_No });
    this.updatePersonalDetailsForm.patchValue({ aadharPhotoPath: val.Aadhaar_Copy_Upload });
    this.updatePersonalDetailsForm.patchValue({ isSubsidyAvailabe: val.IsSubsidyAvailabe });

    this.onSelectSubsidyAvailUpdate(val.IsSubsidyAvailabe);

    this.updatePersonalDetailsForm.patchValue({ installedSystem: val.InstalledSystem1 });
    this.updatePersonalDetailsForm.patchValue({ yearSubsudy: val.YearSubsudy });
    this.updatePersonalDetailsForm.patchValue({ onCostSubsidyBased: val.OnCostSubsidyBased });
    this.updatePersonalDetailsForm.patchValue({ departmentSubsidy: val.DepartmentSubsidy });
  }

  deletePersonalDetails(val) {

    let reqBody = {
      appId: val?.APP_ID,
      contractorId: this.contractorId,
      agreementNo: this.agreementNoToGetData?.AgreementNo,
      outletId: this.selectedOutletToGetData?.OutletId,
      ChunkId: this.chunkIdToGetData?.ChunkId ? this.chunkIdToGetData?.ChunkId : 0,
      network_Id: this.ipAddress,
      terminal_Id: this.ipAddress
    }


    this.delConfirmatioMsg(reqBody);
  }

  delConfirmatioMsg(reqBody) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Do you want to delete ${reqBody?.appId} record? Once you delete this farmer data, estimation should also be deleted.`,
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: "p-button-danger p-button-text",
      rejectButtonStyleClass: "p-button-text p-button-text",
      acceptIcon: "none",
      rejectIcon: "none",

      accept: () => {
        this.deleteFarmerPersonalData(reqBody);
      },
      reject: () => {
        // this.messageService.add({ severity: 'info', summary: 'Rejected', detail: 'You have rejected' });
      }
    });
  }

  deleteFarmerPersonalData(reqBody) {
    this.loader.start();
    this.vendorService
      .deleteFarmerPersonalDetails(reqBody)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();

          let resp: any = res;
          if (resp == 'Success') {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: resp,
            });

            this.hideGetDataButton = false;
            this.addedFarmerData = [];
            this.programWiseData = [];
            this.estimationTableData = [];

            this.clearGetData();

          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Error Message',
              detail: resp,
            });
          }

          this.activityRecordService.activityRecord(this.contractorId, 'Vendor Reg delete Farmer Data', this.userId, new Date(), `${res}`, JSON.stringify(reqBody));

        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });

          this.activityRecordService.activityRecord(this.contractorId, 'Vendor Reg delete Farmer Data(Error)', this.userId, new Date(), `${err}`, JSON.stringify(reqBody));
        },
      });
  }

  onCloseUpdatePerDialog() {
    this.showUpdatePersonalDialog = false;
  }

  onClickAgreementNo() {
    let outletId = this.selectedOutletToGetData?.OutletId;
    let contractorId = this.selectedOutletToGetData?.ContractorCode;
    let agreementNo = this.agreementNoToGetData?.AgreementNo;

    this.getChunkIdsList(contractorId, agreementNo, outletId, this.userId, '');
  }

  getChunkIdsList(contractorId, agreementNo, outletId, userId, status) {
    this.loader.start();
    this.fApplicationService
      .getChunkIds(contractorId, agreementNo, outletId, userId, status)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          this.chunkList = res.map(val => ({
            ...val,
            combineData: `${val?.ChunkId}. ${val?.FarmerName} (${val?.AppId})`
          }));
        },
        error: (err) => {
          this.loader.close();
          this.chunkList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }
  onUpload(event, formcontrol, uploadElement) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);
    
    // this._personalDetalSer.uploadFile(data, this.getMobile, formcontrol).subscribe((resp: any) => {
    //   if (resp.statusCode == 200) {
    //     this.estimationDetailsForm.patchValue({ [formcontrol]: resp.data });
    //   }
    // })

    this._personalDetalSer.uploadNewRegFile(data, this.getMobile, formcontrol).subscribe(
      (resp: any) => {
        this.loader.close();
        if (resp.statusCode == 200) {
          this.estimationDetailsForm.patchValue({ [formcontrol]: resp.data });
        
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'File Uploaded Successfully',
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Oops! Someting went wrong.',
          });
        }
      },
      (err) => {
        this.loader.close();
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: err,
        });
      }
    );
    uploadElement.clear();
  }

  onSelectListData(){
    this.estimationDetailsForm.controls['cmlSerialNo'].reset();
    this.estimationDetailsForm.controls['cmlValidity'].reset();
    this.estimationDetailsForm.controls['cmL_Certificate'].reset();
    this.estimationDetailsForm.controls['price'].reset();
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'MI System': d.MI_System_Name,
          'Category': d?.Component_Cat,
          'Component': d?.Component,
          'Size': d?.Component_Size,
          'Price': d?.Price,
          'CML Sr No': d?.CML_SrNo,
          'CML Validity': d?.CML_Validity,
          // 'CML Certificate': d?.CML_Certificate,
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  onDeleteAddedCompRow(row, index){
    // console.log(row)
    let reqBody = {
      SrNo: JSON.stringify(row?.SrNo),
      NetworkId: this.ipAddress,
      TerminalId: this.ipAddress
    }

    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Do you want to delete?`,
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: "p-button-danger p-button-text",
      rejectButtonStyleClass: "p-button-text p-button-text",
      acceptIcon: "none",
      rejectIcon: "none",

      accept: () => {
        this.deleteAddedCompRow(reqBody);
      },
      reject: () => {
        // this.messageService.add({ severity: 'info', summary: 'Rejected', detail: 'You have rejected' });
      }
    });
  }

  deleteAddedCompRow(reqBody) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    console.log('reqBodyAfterEncypt', reqBody);

    this.loader.start();
    this.fApplicationService
      .deleteVendorRegComp(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();

          if(res == 'Success') {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: 'Record deleted successfully.',
            });

            this.getVendorFullDetailsByEmail();
          }else{
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: res,
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.chunkList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }
}
